import React from 'react'
import styles from './Step4.scss'
import {S2DLayout} from '../../../S2DLayout'
import androidRideThisMp4 from 'assets/images/send_to_device/android_ride_this.mp4'
import androidRideThisWebm from 'assets/images/send_to_device/android_ride_this.webm'

import iosRideThisMp4 from 'assets/images/send_to_device/ios_ride_this.mp4'
import iosRideThisWebm from 'assets/images/send_to_device/ios_ride_this.webm'

export class Step4 extends React.PureComponent {
  render () {
    const {title, subtitle, step, onPrev, route, selectedDevice, stepCount} = this.props
    const mp4 = selectedDevice === 'iphone'
      ? iosRideThisMp4
      : androidRideThisMp4
    const webm = selectedDevice === 'iphone'
      ? iosRideThisWebm
      : androidRideThisWebm
    return (
      <S2DLayout
        title={title}
        subtitle={subtitle}
        step={step}
        onClickNext={() => { window.location.href = `/routes/${route.id}` }}
        onClickPrev={onPrev}
        stepCount={stepCount}
        nextText='Return to Route'>
        <div className={styles.Step4}>
          <div>
            <video width='240' height='426' autoPlay muted loop key='step3'>
              <source src={webm} type='video/webm' />
              <source src={mp4} type='video/mp4' />
            </video>
          </div>
          <div>
            <h3>When you're ready to navigate, tap the <strong>Navigate</strong> button at the bottom of the screen.</h3>
            <h3>After a brief warmup, you will be ready to go.</h3>
            <h3>Enjoy your ride!</h3>
          </div>
        </div>
      </S2DLayout>
    )
  }
}
